// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// Si necesitas Auth, Storage, etc., también importas de "firebase/auth", etc.

const firebaseConfig = {
    apiKey: "AIzaSyAEHDQWS2oCP9QXYxpBH9u0JpV3KYRDSi8",
    authDomain: "the-thing-mkt.firebaseapp.com",
    projectId: "the-thing-mkt",
    storageBucket: "the-thing-mkt.appspot.com",
    messagingSenderId: "36601006532",
    appId: "1:36601006532:web:9427adb747e4d28be03c91"
  };
// Inicializa la app de Firebase
const app = initializeApp(firebaseConfig);

// Inicializa Firestore
export const db = getFirestore(app);

// Aquí podrías exportar otros servicios de Firebase si los necesitas

